/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkQuantityDiscountPatchRequest } from '../../models/bulk-quantity-discount-patch-request';
import { BulkQuantityDiscountSynchronizeResponse } from '../../models/bulk-quantity-discount-synchronize-response';

export interface BulkQuantityDiscountPatch$Params {
      body: BulkQuantityDiscountPatchRequest
}

export function bulkQuantityDiscountPatch(http: HttpClient, rootUrl: string, params: BulkQuantityDiscountPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkQuantityDiscountPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkQuantityDiscountSynchronizeResponse>;
    })
  );
}

bulkQuantityDiscountPatch.PATH = '/discounts/bulk-synchronize';
